// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:38:01

export default {
  "id": "worldcraft-3",
  "slug": "worldcraft-3",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a7c2f298ce5a4c6ea595b1f58cf5dc2a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a7c2f298ce5a4c6ea595b1f58cf5dc2a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "WorldCraft 3",
      "description": "Are you ready to survive in pixel world ? This is a challenge game survive in the pixel worlds, You have to prepare for every situations. You can fly and with your grenade you explode blocks world. You can collect items to your inventory",
      "instructions": "Movement: W,A,S,D\nBreak: Left Click Mouse\nBuild: Right Click Mouse\nFly: F\nInventory: Tab\nChoose Items: 1,2,3,4,5,6,7,8,9,0\nBack to Menu: Escape",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3d",
        "build",
        "crafting",
        "minecraft"
      ]
    },
    "zh-CN": {
      "title": "世界工艺3",
      "description": "你准备好在像素世界中生存了吗？这是一款在像素世界中生存的挑战游戏，你需要为各种情况做好准备。你可以飞行，并使用你的手榴弹炸毁方块世界。你可以收集物品到你的库存中",
      "instructions": "移动：W、A、S、D\n破坏：鼠标左键点击\n建造：鼠标右键点击\n飞行：F\n打开背包：Tab\n选择物品：1、2、3、4、5、6、7、8、9、0\n返回菜单：Esc",
      "genres": [
        "模拟"
      ],
      "tags": [
        "三维",
        "建造",
        "制作",
        "我的世界"
      ]
    },
    "zh-TW": {
      "title": "世界工坊3",
      "description": "你準備在像素世界中求生存嗎？這是一款挑戰性的生存遊戲，在像素世界中生存，你必須為每一種情況做好準備。你可以飛行，並使用你的手榴彈炸毀世界中的塊塊。你可以收集物品到你的儲物櫃中",
      "instructions": "移動：W,A,S,D\n破壞：左鍵點擊滑鼠\n建造：右鍵點擊滑鼠\n飛行：F\n物品庫：Tab\n選擇物品：1,2,3,4,5,6,7,8,9,0\n返回主選單：Escape",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "建造",
        "製作",
        "我的世界"
      ]
    },
    "zh-HK": {
      "title": "世界工場3",
      "description": "你準備在像素世界中生存嗎？這是一款挑戰遊戲，要在像素世界中生存，你必須為每一種情況做好準備。你可以飛行，並用你的手榴彈炸毀世界中的塊狀物體。你可以收集物品到你的儲物櫃中",
      "instructions": "移動：W,A,S,D\n破壞：左鍵按鈕\n建造：右鍵按鈕\n飛行：F\n物品庫：Tab\n選擇物品：1,2,3,4,5,6,7,8,9,0\n返回主選單：Escape",
      "genres": [
        "模擬"
      ],
      "tags": [
        "3D",
        "建築",
        "製作",
        "Minecraft"
      ]
    },
    "ja": {
      "title": "ワールドクリفت3",
      "description": "ピクセル世界で生き延びる準備はできましたか？これはピクセル世界で生き延びる挑戦的なゲームです。どんな状況にも準備をしなければなりません。飛行ができますし、グレネードを使ってブロック世界を爆破できます。アイテムをインベントリに収集することができます",
      "instructions": "移動: W,A,S,D\n割る: 左クリック\n建設: 右クリック\n飛行: F\nインベントリ: Tab\nアイテムを選択: 1,2,3,4,5,6,7,8,9,0\nメニューに戻る: Escape",
      "genres": [
        "シミュレーション"
      ],
      "tags": [
        "3D",
        "建造",
        "クラフティング",
        "マイクラ"
      ]
    },
    "ko": {
      "title": "월드크래프트 3",
      "description": "픽셀 월드에서 생존할 준비가 되셨나요? 이는 픽셀 월드에서 생존하는 도전 게임입니다. 모든 상황에 대비해야 합니다. 날 수 있으며, 그레나데를 사용하여 블록 월드를 폭발시킬 수 있습니다. 인벤토리에 아이템을 수집할 수 있습니다.",
      "instructions": "이동: W, A, S, D\n빔: 마우스 왼쪽 클릭\n건설: 마우스 오른쪽 클릭\n비행: F\n인벤토리: Tab\n아이템 선택: 1,2,3,4,5,6,7,8,9,0\n메뉴로 돌아가기: Escape",
      "genres": [
        "시뮬레이션"
      ],
      "tags": [
        "3D",
        "건축",
        "제작",
        "마인크래프트"
      ]
    },
    "fr": {
      "title": "WorldCraft 3",
      "description": "Prêt à survivre dans le monde pixel ? C'est un jeu de survie dans les mondes pixelisés, vous devez vous préparer à toutes les situations. Vous pouvez voler et avec votre grenade, vous pouvez faire exploser les blocs du monde. Vous pouvez collecter des objets dans votre inventaire.",
      "instructions": "Mouvement : W, A, S, D\nCasser : Clic gauche de la souris\nConstruire : Clic droit de la souris\nVol : F\nInventaire : Tab\nChoisir des objets : 1, 2, 3, 4, 5, 6, 7, 8, 9, 0\nRetour au menu : Échap",
      "genres": [
        "Simulation"
      ],
      "tags": [
        "3D",
        "construction",
        "craft",
        "Minecraft"
      ]
    }
  }
};
